'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BcReactComponent = require('./components/BcReactComponent.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BcReactComponent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/bc-react-component/lib/index.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8 9